import PrimeTooltip from 'primevue/tooltip';

// Tooltip `class` value used by resources/js/utilities/longTitleTooltip.js.
// Only this is gated on truncation — other app tooltips are unaffected.
const TRUNCATION_GATED_CLASSES = new Set(['nav-title-tooltip']);

function isOverflowing(el) {
    return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
}

/**
 * Wrap the native mouseenter/focus listener PrimeVue just attached so it only
 * shows the tooltip when the label is actually clamped. Layout isn't settled
 * yet when the directive binds, so this checks at trigger time instead of
 * pre-computing truncation.
 */
function gateShowOnTruncation(el, binding) {
    if (!TRUNCATION_GATED_CLASSES.has(binding.value?.class)) {
        return;
    }

    for (const [key, eventName] of [
        ['$_ptooltipMouseEnterEvent', 'mouseenter'],
        ['$_ptooltipFocusEvent', 'focus'],
    ]) {
        const original = el[key];

        if (!original || original.$_truncationGated) {
            continue;
        }

        el.removeEventListener(eventName, original);

        const gated = function truncationGatedListener(event) {
            if (isOverflowing(el)) {
                original.call(this, event);
            }
        };
        gated.$_truncationGated = true;

        el.addEventListener(eventName, gated);
        el[key] = gated;
    }
}

/**
 * PrimeVue's tooltip directive removes overlay nodes on unmount. When many
 * sidebar nav items re-render at once (course menu tree), that cleanup can race
 * Vue's DOM teardown and throw NotFoundError on removeChild. Swallow that case.
 */
export default {
    ...PrimeTooltip,
    beforeMount(el, binding, ...args) {
        PrimeTooltip.beforeMount(el, binding, ...args);
        gateShowOnTruncation(el, binding);
    },
    updated(el, binding, ...args) {
        PrimeTooltip.updated(el, binding, ...args);
        gateShowOnTruncation(el, binding);
    },
    unmounted(el, binding, vnode, prevVnode) {
        try {
            PrimeTooltip.unmounted(el, binding, vnode, prevVnode);
        } catch (error) {
            if (error?.name !== 'NotFoundError') {
                throw error;
            }
        }
    },
};
